import React from 'react';

import LargeLogoBlack from '~IMAGES/logos/nameplate-black.svg';

export const HeaderLogoPF = () => (
  <div className='flex-container center mb1-sm hide-screen' aria-label={`${import.meta.env.VITE_APP_NAME}`}>
    <img alt='' src={LargeLogoBlack} className='largeLogo' />
  </div>
);

export default HeaderLogoPF;
